import { AuthProvider } from '../context/AuthContext';
import { reportRoutes } from '../routes';
import { b2cRoutes } from '../../b2c/routes';
import Layout from '../layout/Layout';
import { Routes, Route } from 'react-router-dom';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { STORAGE_KEY, config, labelsPath, imgsPath } from '../config';
import { getJSONItem } from '../services/storage/storage';
import LayoutB2C from '../../b2c/layout/LayoutB2c';

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: getJSONItem(STORAGE_KEY.LANGUAGE, 'it'),
    fallbackLng: 'it',

    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: () => labelsPath,
    },
  });

const App = () => (
  <AuthProvider>
    <Routes>
      <Route element={<Layout logo={`${imgsPath}${config.appLogo}`} />}>
        {reportRoutes.map((route, i) => (
          <Route {...route} key={`${route.path}-${i}`} />
        ))}
      </Route>
      {config.abtest !== 'sauton' && (
        <Route path="/b2c" element={<LayoutB2C logo={`${imgsPath}${config.b2cLogo}`} />}>
          {b2cRoutes.map((route, i) => (
            <Route {...route} key={`${route.path}-${i}`} />
          ))}
        </Route>
      )}
    </Routes>
  </AuthProvider>
);

export default App;
